module.exports = __webpack_public_path__ + "static/img/suisui1.db359eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suisui1.svg
// module id = Ajf2
// module chunks = 0